import { createReducer } from '../../utilities';
import {
    FAIL_GET_COLLECTIONS,
    REQUEST_GET_COLLECTIONS,
    SUCCESS_GET_COLLECTIONS
} from "../../../actions/entities/jerseys";


const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { response } = action;
    return {
        ...state,
        data: response.jerseyCollectionsTemp,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_GET_COLLECTIONS]: requestFetch,
    [SUCCESS_GET_COLLECTIONS]: successFetch,
    [FAIL_GET_COLLECTIONS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/jerseys/collections.js